import React from 'react';
import { Badge } from './ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import { timeAgo, getFreshnessLevel } from '../lib/utils';
import { Clock, CheckCircle, AlertCircle } from 'lucide-react';

export default function FreshnessChip({ lastUpdate, dataSource }) {
  const level = getFreshnessLevel(lastUpdate);

  const config = {
    good: { bg: 'bg-emerald-50 text-emerald-700 border-emerald-200', icon: CheckCircle, label: 'Aktuell' },
    warn: { bg: 'bg-amber-50 text-amber-800 border-amber-200', icon: Clock, label: 'Veraltet' },
    stale: { bg: 'bg-slate-100 text-slate-600 border-slate-200', icon: AlertCircle, label: 'Nicht aktuell' },
  };

  const { bg, icon: Icon, label } = config[level];

  const sourceLabel = {
    self_reported: 'Anbieter-Daten',
    import: 'Importiert',
    manual: 'Manuell gepflegt',
    scraped: 'Automatisch erfasst',
    api: 'Anbieter-API',
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant="outline" className={`${bg} text-[10px] cursor-help gap-1`} data-testid="provider-freshness-chip">
            <Icon className="w-3 h-3" />
            {label}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          <div className="text-xs">
            <p>Quelle: {sourceLabel[dataSource] || dataSource}</p>
            <p>Aktualisiert: {timeAgo(lastUpdate)}</p>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
